<template>
    <div class="inner-wrapper">
        <div class="alert alert-success" role="alert" v-if="successMessage">
            {{ successMessage }}
        </div>

        <div class="page-title">
            <h1 class="float-left">Draft Quotations</h1>
            <div class="title-right float-right">

            </div>
        </div>
        <div class="new-rfq">
            <fieldset class="customer-search mb-3">
                <div class="row">
                    <div class="col-sm-7 col-md-7">
                        <form class="form-inline list-search" action="">
                            <div class="quotes-text">{{quotationData.count}} Quotes</div>
                            <div class="input-group">
                                <input v-model="filterData.search_filter" type="text" class="form-control"
                                       placeholder="Quick Search">
                                <div class="input-group-append">
                                    <button class="btn btn-success" type="button" @click.prevent="search"><i
                                        class="fa fa-search" aria-hidden="true"></i></button>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div class="col-sm-5 col-md-5">
                        <div class="btnrow float-right">
                            <router-link v-if="quotationData.can_add_quotation" :to="{ name: 'addQuotePage'}" class="btn create-btn">
                                <i class="fa fa-plus" aria-hidden="true"></i> Create RFQ
                            </router-link>
                        </div>
                    </div>
                </div>
            </fieldset>

            <QuotationList :current_page="current_page"
                           :total="total"
                           :per_page="per_page"
                           :user_type="quotationData.user_type"
                           :role="quotationData.role"
                           :can_delete_quotation="quotationData.can_delete_quotation"
                           :quotations="quotationData.quotations"
                           :is_draft="1"
                           @deleteItem="deleteQuotation"
                           @changeCurrentPage="changeCurrentPage"></QuotationList>


        </div>

        <footer class="footer">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-6">
                                2022 © Superb.
                            </div>
                            <div class="col-sm-6">
                                <div class="text-right d-none d-sm-block">
                                    All Rights Reserved.
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>


    </div>
</template>

<script>
import { mapState, mapActions, mapGetters  } from 'vuex';
import axios from "axios";
import Vue from "vue";

import QuotationList from "../../components/QuotationList";

export default {
    name: "DraftQuotation",
    components: {
        QuotationList
    },
    created() {
        this.getQuotations();
    },
    data() {
        return {
            bus: new Vue(),
            totalOrders: 0,
            showFilters: false,
            filterData: {
                search_filter: null,
                date_filter: null,
                user_id: null,
                status: null,
                tab: null,
                customer_id: null,
                date_range: null,
                type: null,
                cus_id: null,
                start: null,
                end: null,
                customer_user: null
            },
            quotationData: {
                quotations: null,
                reminder_quote: null,
                type: null,
                notify: null,
                adminNotification: null,
                OtherNotification: null,
                DesktopNotification: null,
                cus_id: null,
                start: null,
                end: null,
                count: null,
                config: null,
                quotations_data: null,
                status: null,
                sale_users: null,
                quote_time: null,
                active_tab: 'one',
                admin_users: null,
                check_filter: null,
                can_add_quotation:  false,
                can_delete_quotation: false,
                user_type: null,
                role: null
            },
            current_page: 1,
            per_page:10,
            total:0,
            scrollPage: 1,
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomerLoading',
            'setLoading'
        ]),
        setTotalOrders(event) {
            this.totalOrders = event;
        },
        changeCurrentPage(current_page){
            this.current_page = current_page;
        },
        changeScrollPage(scrollPage) {
            this.scrollPage = scrollPage;
            this.loadMore();
        },
        deleteQuotation(event) {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('deleteQuote'), event,{
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.setSuccessMessage(data.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        self.getQuotations();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getQuotations() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('quotations.index', {is_draft: 1}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.quotationData = data.data;


                        this.current_page = data.data.quotations.current_page;
                        this.per_page = data.data.quotations.per_page;
                        this.total = data.data.quotations.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        search() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('quotations.ajaxLoad', {
                _query: {
                    page: this.current_page,
                    is_draft: 1
                }
            }), this.filterData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.quotationData.quotations = data.data.quotations;
                        this.quotationData.quote_time = data.data.quote_time;
                        this.quotationData.count = data.data.count;
                        this.quotationData.config = data.data.config;
                        this.quotationData.quotations_data = data.data.quotations_data;
                        this.quotationData.active_tab = data.data.active_tab;

                        this.current_page = data.data.quotations.current_page;
                        this.per_page = data.data.quotations.per_page;
                        this.total = data.data.quotations.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        loadMore() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('status.ajaxLoadOnScroll', {
                _query: {
                    page: this.scrollPage,
                    is_draft: 1
                }
            }), this.filterData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.quotationData.quotations_data = data.data.quotations_data;
                        this.quotationData.quote_time = data.data.quote_time;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        }

    },
    watch: {
        current_page: {
            handler: function(value) {
                if(value != 1){
                    this.search();
                }
            }
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading'
        ])
    }
}
</script>

<style scoped>

</style>
